import { Workspace } from "@/components/graphql/schema.graphql";

interface WorkspaceFeatureFlags {
  workspaceModelsPolicyEnabled?: boolean;
}

export type FeatureFlag = keyof WorkspaceFeatureFlags;

export type FeatureFlags = Record<FeatureFlag, boolean>;

// PostHog flag key -> the name this app knows it by.
const featureFlagMapping: {
  [key: string]: FeatureFlag;
} = {
  "workspace-models-policy": "workspaceModelsPolicyEnabled",
};

export const extractFeatureFlags = (
  workspaceFeatureFlagList: Workspace["featureFlags"],
) => {
  return workspaceFeatureFlagList.reduce((acc, flag) => {
    if (!flag) return acc;

    const key = featureFlagMapping[flag];
    if (key) {
      acc[key] = true;
    }

    return acc;
  }, {} as FeatureFlags);
};
